export default __webpack_public_path__ + "static/media/AllPlansBrochure.835c3fc5.pdf";